import React, { useState, useMemo } from 'react';

const ALL_THEMES = [
  { name: 'Adventure', emoji: '🏔️' },
  { name: 'Magic', emoji: '✨' },
  { name: 'Animals', emoji: '🐾' },
  { name: 'Space', emoji: '🚀' },
  { name: 'Ocean', emoji: '🌊' },
  { name: 'Friendship', emoji: '💛' },
  { name: 'Superheroes', emoji: '🦸' },
  { name: 'Nature', emoji: '🌿' },
  { name: 'Mystery', emoji: '🔮' },
  { name: 'Kindness', emoji: '❤️' },
  { name: 'Dragons', emoji: '🐉' },
  { name: 'Underwater', emoji: '🐠' },
];

function pickRandom3(arr) {
  const shuffled = [...arr].sort(() => Math.random() - 0.5);
  return shuffled.slice(0, 3);
}

const themeCardHoverStyle = `
  .theme-vote-card {
    transition: transform 0.18s ease, box-shadow 0.18s ease;
    cursor: pointer;
  }
  .theme-vote-card:hover {
    transform: scale(1.05);
    box-shadow: 0 6px 24px rgba(111, 66, 193, 0.25);
  }
`;

const ThemeVotingCard = ({ childName, onThemeSelected, onSkip }) => {
  const [hovered, setHovered] = useState(null);

  const selectedThemes = useMemo(() => pickRandom3(ALL_THEMES), []);

  return (
    <>
      <style>{themeCardHoverStyle}</style>
      <div
        className="rounded-4 p-4"
        style={{
          background: 'var(--card-bg)',
          border: '1px solid var(--border-purple)',
        }}
      >
        <h4
          style={{
            fontFamily: "'Fredoka One', cursive",
            fontSize: '22px',
            color: 'var(--text-main)',
            marginBottom: '20px',
          }}
        >
          What kind of story does {childName || 'your child'} want tonight? 🌙
        </h4>

        <div className="d-flex gap-3 flex-wrap mb-3">
          {selectedThemes.map((theme) => (
            <div
              key={theme.name}
              className="theme-vote-card rounded-4 p-3 text-center"
              style={{
                background: hovered === theme.name ? 'var(--purple-section-2)' : 'var(--purple-section)',
                border: '1px solid var(--border-purple)',
                minWidth: '110px',
                flex: '1 1 110px',
              }}
              onClick={() => onThemeSelected(theme.name)}
              onMouseEnter={() => setHovered(theme.name)}
              onMouseLeave={() => setHovered(null)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') onThemeSelected(theme.name);
              }}
              aria-label={`Select ${theme.name} theme`}
            >
              <div style={{ fontSize: '48px', lineHeight: 1, marginBottom: '8px' }}>
                {theme.emoji}
              </div>
              <div
                style={{
                  fontFamily: "'Fredoka One', cursive",
                  fontSize: '16px',
                  color: 'var(--text-main)',
                }}
              >
                {theme.name}
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-2">
          <button
            className="btn btn-link"
            style={{ color: 'var(--text-muted2)', textDecoration: 'none', fontSize: '14px' }}
            onClick={onSkip}
          >
            Let me choose the theme →
          </button>
        </div>
      </div>
    </>
  );
};

export default ThemeVotingCard;
